import {Move} from './move';


Move.addListener((e) => {
  document.documentElement.style.setProperty('--x', `${e.x}`);
  document.documentElement.style.setProperty('--y', `${e.y}`);
});